import { useState } from "react";
import makeAnimated from "react-select/animated";
import AsyncSelect from "react-select/async";
import useGetHook from "../../../customHooks/useGetHook";
import { type Control, Controller } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const animatedComponents = makeAnimated();

interface Props {
  label: string;
  queryKey: string;
  params: {
    [key: string]: any;
  };
  name: string;
  control: Control;
  url: string;
  limit?: number;
  [key: string]: any;
}

const MultipleSelectField = ({
  label,
  queryKey,
  params,
  name,
  control,
  url,
  limit = 10,
  ...otherProps
}: Props) => {
  const [query, setQuery] = useState("");

  const { data: serverData } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${query}`],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: query,
      ...params,
    },
  });

  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    setQuery(inputValue?.length == 1 ? "" : inputValue);
    setTimeout(() => {
      callback(
        serverData?.results?.map((item: any, index: number) => ({
          label: item?.name,
          value: item?.id,
        }))
      );
    }, 1000);
  };

  return (
    <div className={tw`mt-2`}>
      <label htmlFor="">{label}</label>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => (
          <>
            <AsyncSelect
              {...field}
              loadOptions={loadOptions}
              components={animatedComponents}
              closeMenuOnSelect={false}
              isMulti
              styles={{
                control(base, props) {
                  return {
                    ...base,
                    backgroundColor: "#EEF5F4",
                    border:
                      props.menuIsOpen || props.isFocused ? "none" : "none",
                    outline:
                      props.menuIsOpen || props.isFocused
                        ? "none !important"
                        : "none  !important",
                    cursor: "text",
                  };
                },
              }}
              defaultOptions={
                serverData?.results?.map((item: any, index: number) => ({
                  label: item?.name,
                  value: item?.id,
                })) ?? []
              }
            />
            {error && (
              <p className={tw`text-red-500 text-xs py-1`}>{error?.message}</p>
            )}
          </>
        )}
      />
    </div>
  );
};

export default MultipleSelectField;
